import './list.scss';
import { Outlet, useNavigate } from "react-router-dom";


const MenuList = ({ menuList }) => {

     const navigate = useNavigate();

    return (
        <div className="row menu-list">
            {
                menuList.map((e, i) => {
                    return (
                        <div key={i + 'title'}>
                            <p className="menu-list-title mt-5 mb-0" >{e.title}</p>
                            {
                                e.list.map((e, i)=> {
                                    return (
                                        <div className="col-md-12 pt-2" key={i} onClick={() => {
                                            if (e.isLogout) {
                                                sessionStorage.clear();
                                            }
                                            if (e.link) {
                                                navigate(e.link)
                                            }
                                        }}>
                                            <div className="d-flex justify-content-between align-item-center">
                                                <img src={e.icon} />
                                                <p className="w-100 px-3 pt-1 mb-0 pb-0">{e.name}</p>
                                                <i className="bi bi-arrow-right-short text-white align-middle" style={{ fontSize: '24px' }}></i>
                                            </div>
                                            <hr className="list-line m-0 p-0" />
                                        </div>
                                    )
                                })
                            }

                        </div>
                    )
                })
            }
        </div>
    )
}

export default MenuList;